<div class="container">
  <hyperkit-typography
    class="page-title"
    variant="h1"
    align="left"
    color="primary"
    >Appearance</hyperkit-typography
  >
  <div class="appearance-wrapper">
    <section class="section">
      <div class="section-title">
        <hyperkit-typography variant="h4" align="left" color="primary"
          >Theme</hyperkit-typography
        >
      </div>
      <hyperkit-toggle
        labelLeft="Light"
        labelRight="Dark"
        [isChecked]="theme === 'dark'"
        (changed)="toggleTheme()"
      >
      </hyperkit-toggle>
    </section>
  </div>
</div>
